import { generatePath } from 'react-router';
import { PAGE_ADMIN_CNT_01_URL } from 'types/url';

export const breadcrumb = (idOperator) => [
  {
    slash: 'Home',
    url: '',
  },
  {
    slash: 'Area personale',
    url: 'areaPersonale',
  },
  {
    slash: 'Gestione Contenuti',
    url: generatePath(PAGE_ADMIN_CNT_01_URL, { idOp: idOperator }),
  },
  {
    slash: 'Gestione Aree dei servizi (Categorie Livello 1)',
    url: '',
  },
];
